package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.Composable
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorIntegerInput
import com.exura.ui.Dimens
import com.exura.ui.TextStyles
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

@Composable
internal fun EstimatedMinutesSection(
    estimatedMinutes: Int,
    onEstimatedMinutesChange: (Int) -> Unit,
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
) = EditViewSection(
    enabled = enabled,
    title = "Czas wykonania"
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(12.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        SpanText("Około")

        PlanCreatorIntegerInput(
            value = estimatedMinutes,
            onValueChange = onEstimatedMinutesChange,
            mode = mode,
            textStyle = TextStyles.medium16,
            minValue = 1
        )

        SpanText("minut")
    }
}
